import React from "react";
import { Switch, Route } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import ScrollToTopOnMount from "../utils/ScrollToTopOnMount";

import "./adminApp.css";

import Navbar from "./Navbar/Navbar";

import OrdersSection from "./OrdersPanel/OrdersSection";
import MenusSection from "./MenuPanel/MenusSection";
import DishesSection from "./DishesPanel/DishesSection";
import ConfigSection from "./ConfigPanel/ConfigSection";
import OrdersStats from "./OrdersStats/OrdersStats";
import PromosSection from "./PostsPanel/PromosSection";
import LandingSection from "./LandingPanel/LandingSection";
import Component404 from "../utils/ui_components/404Component";

const sortMenus = (a, b) => {
  let A = a.menuDate;
  let B = b.menuDate;

  if (A > B) {
    return -1;
  } else if (B > A) {
    return 1;
  } else {
    return 0;
  }
};

const AdminApp = ({
  handleLogout,
  activeOrders,
  setActiveOrders,
  isActiveOrdersLoading,
  handleUpdateOrderAdmin,
  handleUpdateOrderChef,
  handleConfirmOrder,
  handleInactivateOrder,
  allMenus,
  isAllMenusLoading,
  handleCreateNewMenu,
  handleUpdateMenu,
  handleToggleMenuActive,
  handleDeleteMenu,
  dishes,
  handleCreateDish,
  handleUpdateDish,
  handleDeleteDish,
  config,
  setConfig,
  promos,
  handleCreatePromopost,
  handleTogglePromopostActive,
  handleUpdatePromopost,
  handleDeletePromopost,
  mediaURLs,
  setMediaURLs
}) => {
  return (
    <>
      <Navbar
        activeUncheckedOrders={
          activeOrders &&
          activeOrders.filter((order) => order.orderStatus === "requested")
        }
        handleLogout={handleLogout}
      />
      <div className="segment chefApp__segment">
        <Route
          render={({ location, match }) => {
            const { pathname, key } = location;

            return (
              <TransitionGroup component={null}>
                <CSSTransition
                  in={pathname != null}
                  key={location.key}
                  timeout={300}
                  classNames="section"
                  unmountOnExit
                >
                  <ScrollToTopOnMount>
                    <Switch location={location}>
                      <Route path="/orders">
                        <OrdersSection
                          activeOrders={
                            activeOrders &&
                            activeOrders
                              .filter((o) => o.active)
                              .filter(
                                (order) => order.orderType === "dailymenuOrder"
                              )
                          }
                          setActiveOrders={setActiveOrders}
                          isActiveOrdersLoading={isActiveOrdersLoading}
                          handleUpdateOrderAdmin={handleUpdateOrderAdmin}
                          handleUpdateOrderChef={handleUpdateOrderChef}
                          handleConfirmOrder={handleConfirmOrder}
                          handleInactivateOrder={handleInactivateOrder}
                        />
                      </Route>
                      <Route path="/menus">
                        <MenusSection
                          allMenus={allMenus}
                          dishes={dishes}
                          handleCreateNewMenu={handleCreateNewMenu}
                          handleUpdateMenu={handleUpdateMenu}
                          handleToggleMenuActive={handleToggleMenuActive}
                          handleDeleteMenu={handleDeleteMenu}
                        />
                      </Route>
                      <Route path="/items">
                        <DishesSection
                          dishes={dishes}
                          handleDeleteDish={handleDeleteDish}
                          handleCreateDish={handleCreateDish}
                          handleUpdateDish={handleUpdateDish}
                        />
                      </Route>
                      <Route path="/config">
                        <ConfigSection config={config} setConfig={setConfig} />
                      </Route>
                      <Route path="/orders_stats">
                        <OrdersStats
                          orders={activeOrders.filter((o) => !o.active)}
                        />
                      </Route>
                      <Route path="/posts">
                        <PromosSection
                          staticWebsiteMenus={allMenus.filter(
                            (m) => m.websitePurpose === "static"
                          )}
                          promos={promos}
                          handleCreatePromopost={handleCreatePromopost}
                          handleTogglePromopostActive={
                            handleTogglePromopostActive
                          }
                          handleUpdatePromopost={handleUpdatePromopost}
                          handleDeletePromopost={handleDeletePromopost}
                          mediaURLs={mediaURLs}
                          setMediaURLs={setMediaURLs}
                        />
                      </Route>
                      <Route exact path="/">
                        <LandingSection
                          allMenus={allMenus}
                          isAllMenusLoading={isAllMenusLoading}
                          orders={activeOrders}
                          isActiveOrdersLoading={isActiveOrdersLoading}
                        />
                      </Route>
                      <Route path="*" component={Component404} />
                    </Switch>
                  </ScrollToTopOnMount>
                </CSSTransition>
              </TransitionGroup>
            );
          }}
        />
      </div>
      <div className="chefApp__segment__footer">
        <div>Dmitry Zhukov 2020 ©</div>
        <div>Want to augment your business with a custom solution?</div>
        <div>
          Contact me at{" "}
          <a
            style={{ color: "inherit" }}
            target="blank"
            href="https://zdcreatech.com/"
          >
            my website
          </a>
        </div>
        <div style={{ fontSize: "x-small" }}>
          Stock photos from:{" "}
          <a
            target="blank"
            style={{ textDecoration: "none", color: "white" }}
            href="https://www.pexels.com/"
          >
            pexels.com
          </a>
          ,{" "}
          <a
            style={{ textDecoration: "none", color: "white" }}
            href="https://www.foodiesfeed.com/"
            target="blank"
          >
            foodiesfeed.com
          </a>
          .
        </div>
        <div style={{ fontSize: "x-small" }}>
          This website uses cookies to increase user experience.
        </div>
      </div>
    </>
  );
};

export default AdminApp;
